import React from 'react';
import { AlertCircleIcon, CheckCircle2Icon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
import { microStats, problems, solutions } from '../data/content';
export function Transformation() {
  return <section className="w-full bg-cream-100 px-4 py-20" data-id="element-174" data-mp="mktbtebprjxi">
      <div className="mx-auto max-w-5xl" data-id="element-175" data-mp="rlhdqv1hdl6i">
        <div className="text-center" data-id="element-176" data-mp="rmir565yyjre">
          <Eyebrow data-id="element-177" data-mp="wkk6bg09xyxl">La differenza di Scienze Pronta™</Eyebrow>
          <h2 className="mx-auto mt-4 max-w-2xl font-display text-[30px] font-black leading-[1.12] tracking-[-0.015em] text-ink sm:text-[40px]" data-id="element-178" data-mp="wk2504yr8uit">
            Da insegnante esausto a{' '}
            <span className="italic text-brand" data-id="element-179" data-mp="16an927x76r94">guida sicura di sé.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-lg font-sans text-[14px] leading-relaxed text-ink-soft" data-id="element-180" data-mp="1aafbe2w00161">
            Lo stesso programma, la stessa classe, lo stesso tempo a disposizione. Cambia solo
            una cosa: arrivi con un sistema invece che con una buona intenzione.
          </p>
        </div>

        <dl className="mx-auto mt-10 grid max-w-2xl grid-cols-1 divide-y divide-cream-300 rounded-2xl border border-cream-300 bg-cream-50 sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-181" data-mp="1c6tgx4k2o9dw">
          {microStats.map(stat => <div key={stat.value} className="px-6 py-5 text-center" data-id="element-182" data-mp="137g1zwd6isls">
              <dt className="sr-only" data-id="element-183" data-mp="y7k9at9xmnlj">{stat.label}</dt>
              <dd data-id="element-184" data-mp="1uwi2i721adgl">
                <span className="block font-display text-2xl font-black text-brand" data-id="element-185" data-mp="1ux1ez88x09n8">
                  {stat.value}
                </span>
                <span className="mt-1.5 block font-sans text-[10px] font-semibold uppercase tracking-[0.14em] text-ink-muted" data-id="element-186" data-mp="1qvg1bkok3rbz">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-12 grid gap-5 lg:grid-cols-2" data-id="element-187" data-mp="2ek8rt1met6z7">
          <article className="rounded-2xl border border-cream-300 bg-cream-50 p-7" data-id="element-188" data-mp="2eltmqscmyrxl">
            <div className="flex items-start justify-between gap-4" data-id="element-189" data-mp="29t0jk8wtfrnm">
              <div data-id="element-190" data-mp="2spix4sszcay0">
                <p className="font-sans text-[10px] font-bold uppercase tracking-[0.2em] text-ink-muted" data-id="element-191" data-mp="2src2m4ruwp4f">
                  Come funziona oggi
                </p>
                <h3 className="mt-2 font-display text-xl font-black uppercase leading-tight text-ink" data-id="element-192" data-mp="2jxyzyb3zq955">
                  Il costo
                  <br data-id="element-193" data-mp="2ny98nvj63dnp" />
                  dell&apos;improvvisazione
                </h3>
              </div>
              <LockIcon className="h-5 w-5 shrink-0 text-ink-muted" aria-hidden="true" data-id="element-194" data-mp="29yrqhz0dmynb" />
            </div>

            <ul className="mt-6 space-y-2.5" data-id="element-195" data-mp="2f07bjr2k155p">
              {problems.map(item => <li key={item} className="flex items-start gap-3 rounded-xl border border-cream-300 bg-white/70 px-4 py-3" data-id="element-196" data-mp="21069i8ajzron">
                  <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-ink-muted" aria-hidden="true" data-id="element-197" data-mp="3vcmcn081yppa" />
                  <span className="font-sans text-[13px] leading-relaxed text-ink-soft" data-id="element-198" data-mp="36qw4sptwhz5">
                    {item}
                  </span>
                </li>)}
            </ul>
          </article>

          <article className="rounded-2xl border border-brand/25 bg-white p-7 shadow-card" data-id="element-199" data-mp="1xgnmm6kjjmyb">
            <div className="flex items-start justify-between gap-4" data-id="element-200" data-mp="1sq7b4s0a6bel">
              <div data-id="element-201" data-mp="1sow6kpz0gzmf">
                <p className="font-sans text-[10px] font-bold uppercase tracking-[0.2em] text-brand" data-id="element-202" data-mp="1soe3pahufn5j">
                  Con Scienze Pronta™
                </p>
                <h3 className="mt-2 font-display text-xl font-black uppercase leading-tight text-ink" data-id="element-203" data-mp="22f8qcfz04ori">
                  Il sistema
                  <br data-id="element-204" data-mp="2gdff96lz3ef1" />
                  definitivo
                </h3>
              </div>
              <ShieldCheckIcon className="h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-205" data-mp="2belwozrtwx80" />
            </div>

            <ul className="mt-6 space-y-2.5" data-id="element-206" data-mp="m3lg64c5odrv">
              {solutions.map(item => <li key={item} className="flex items-start gap-3 rounded-xl border border-brand/15 bg-brand/[0.04] px-4 py-3" data-id="element-207" data-mp="h4rzy45hi8o0">
                  <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-208" data-mp="nh4eeerh6nps" />
                  <span className="font-sans text-[13px] leading-relaxed text-ink" data-id="element-209" data-mp="xhdew4si2vaz">{item}</span>
                </li>)}
            </ul>
          </article>
        </div>

        <p className="mt-8 text-center font-sans text-[12px] italic text-ink-muted" data-id="element-210" data-mp="4s6gr6wyk7q9">
          La differenza non è quanto lavori, ma con quale materiale entri in classe.
        </p>
      </div>
    </section>;
}